// Importing React classes and functions from node modules
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { selectedId, getSelectedId, deleteAttendance, getAllAttendance, getAttendance, getProfileUsers } from "../data/repository";
import * as XLSX from 'xlsx';

function DisplayAttendanceDates(props) {

    const [attendanceData, setAttendanceData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [confirmPopup, setconfirmPopup] = useState(false);
    const [users, setUsersData] = useState([]);

    // Load users from DB.
    useEffect(() => {

        // Loads User Details from DB
        async function loadUserDetails() {
            const currentDetails = await getProfileUsers();
            setUsersData(currentDetails)
            setIsLoading(false);
        }

        // Loads User Details from DB
        const loadAttendanceData = async () => {
            const attendance = await getAllAttendance();
            setAttendanceData(attendance);
            setIsLoading(false);
        }

        // Calls the functions above
        loadAttendanceData();
        loadUserDetails();

    }, []);

    // Popup Toggle Switch Function
    const togglePopup = () => {
        setconfirmPopup(!confirmPopup);
    }

    const deleteSelectedAttendance = async (event) => {

        const currentDetails = await getAttendance(getSelectedId());

        await deleteAttendance(currentDetails);

        // Update Page/Refresh the Data
        const updatedDetails = await getAllAttendance();
        setAttendanceData(updatedDetails);

        togglePopup();
    }

    const handleSearch = async (event) => {
        setSearch(event.target.value.toLowerCase());
    }

    const exportToExcel = () => {
        const genderFilter = props.user.gender === "Female" ? "Nasirat" : "Atfal";

        // Filtering users based on gender and absence
        const filteredUsers = users.filter(user => {
            if (user.gender !== genderFilter) {
                return false;
            }

            const userAttendance = attendanceData.filter(att => 
                att.attendance.some(record => record.id === user.id)
            );

            // Check if the user is completely absent or doesn't have any attendance records
            return userAttendance.length === 0 || userAttendance.every(att => 
                att.attendance.some(record => record.id === user.id && record.status === 'Absent')
            );
        });

        const formattedData = filteredUsers.map(user => ({
            'Student ID': user.id,
            'Student Name': user.name,
            'Student Group': user.group,
            'Student Gender': user.gender,
            'Fathers Name': user.fathersName,
            'Mothers Name': user.mothersName,
            'Fathers Email': user.fathersEmail,
            'Mothers Email': user.mothersEmail,
            'Student Email': user.studentEmail,
        }));

        // Export the filtered data to an Excel sheet
        const ws = XLSX.utils.json_to_sheet(formattedData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Absent Students');
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        saveExcelFile(excelBuffer, 'Masroor Academy Absent Students.xlsx');
    };

    const saveExcelFile = (buffer, fileName) => {
        const data = new Blob([buffer], { type: 'application/octet-stream' });
        const url = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    return (
        <>
            <br />
            <div className="searchCenter">
                <div className="form-group has-search">
                    <span className="fa fa-search form-control-feedback"></span>
                    <input type="text" style={{ border: "1px solid #112c3f", borderRadius: "10rem" }} className="form-control" placeholder="Search" aria-label="Search" onChange={handleSearch} />
                </div>
            </div>

            <div style={{ display: "flex", justifyContent: "center" }}>
                <button type="button" onClick={exportToExcel} style={{ margin: "5px" }} className="text-center btn btn-primary">Export All Absent Students</button>
            </div>

            <div className="table-responsive">

                {isLoading ?
                    <div className="card-body text-center">
                        <span className="text-muted">Loading Attendance...</span>
                    </div>
                    :
                    <>
                        {attendanceData.length === 0 ?
                            <div className="text-center">
                                <p>&nbsp;</p>
                                <span className="text-muted">No attendance has been marked!</span>
                                <p>&nbsp;</p>
                            </div>
                            :
                            <div>
                                <table className="table table-striped" style={{ margin: "0" }}>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th style={{ color: "#112c3f" }} scope="col">Date</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    {/* Mapping Users state Variable to access its content easily to display in Table */}
                                    {attendanceData.filter((attendance) => {
                                        return search.toLowerCase() === '' ? attendance : (attendance.date && attendance.date.toLowerCase().includes(search));
                                    }).map((attendance) =>
                                        <tbody key={attendance.date}>

                                            <tr>
                                                <td></td>
                                                <td style={{ color: "#112c3f" }}>{new Date(attendance.date).toLocaleDateString('en-GB')}</td>

                                                <td>
                                                    {(props.user.group === "Admin" || (props.user.group === "Principal" && props.user.gender === "Male")) &&
                                                        <button type="submit" style={{ float: "right", textAlign: "right" }} className="btn btn-danger mr-sm-2" onClick={async () => { await selectedId(attendance.date); await togglePopup() }} >Delete</button>
                                                    }
                                                    <Link to={`/ViewAttendance/${attendance.date}`}>
                                                        <button style={{ float: "right", textAlign: "right" }} className="btn2 btn-custom">View</button>
                                                    </Link>
                                                </td>
                                                <td></td>
                                            </tr>

                                        </tbody>
                                    )}
                                </table>
                            </div>
                        }
                    </>
                }
            </div>

            <div>
                {/* Popup box only opens if state variable is set to true for deleting account */}
                {confirmPopup &&
                    <div className="popup-box">
                        <div className="box">
                            <h5 className="card-header bg-warning text-center" style={{ color: "white" }}><b>Confirm!</b></h5>
                            <div style={{ margin: "0 auto", textAlign: "center" }}>
                                <p style={{ padding: "15px", textAlign: "center", color: "red" }}>Are you sure you want delete this Attendance record <br /> This action cannot be undone!</p>
                                <button onClick={togglePopup} className="btn btn-info" style={{ margin: "10px" }}>Cancel</button>
                                <button onClick={async () => { await deleteSelectedAttendance() }} className="btn btn-danger" style={{ margin: "10px" }}>Delete</button>
                            </div>
                        </div>
                    </div>
                }
            </div>

        </>
    )
}

// Export the Student Function
export default DisplayAttendanceDates;